import { useEffect, useState } from 'react'
import { database } from '../firebase'
import { ref, get } from 'firebase/database'
import { usePWAInstall } from '../hooks/usePWAInstall'
import IOSInstallGuide from '../components/IOSInstallGuide'
import '../styles/landing.css'

export default function Availability() {
  const [apkUrl, setApkUrl] = useState('')
  const [showIOSGuide, setShowIOSGuide] = useState(false)
  const [showBrowserGuide, setShowBrowserGuide] = useState(false)
  const { isIOS, isInstallable, triggerInstall } = usePWAInstall()

  useEffect(() => {
    const fetchUrl = async () => {
      const urlRef = ref(database, 'admin_actions/url')
      const snapshot = await get(urlRef)
      if (snapshot.exists()) {
        setApkUrl(snapshot.val())
      }
    }
    fetchUrl()
  }, [])

  const handleInstallPWA = () => {
    if (isIOS) {
      setShowIOSGuide(true)
    } else if (isInstallable) {
      triggerInstall()
    } else {
      setShowBrowserGuide(true)
    }
  }

  return (
    <section id="availability" className="section">
      <div className="container">
        <div className="text-center mb-2xl">
          <h2>Descarga AscensosApp Vortex</h2>
          <p className="section-subtitle">
            Muy pronto disponible en el Play Store, pero ahora descárgala desde esta página y comienza tu viaje hacia tu Ascenso hoy mismo.
          </p>
        </div>

        <div className="availability-grid">
          {/* Content */}
          <div>
            <h3>¡Impulsa tu ascenso en SEMAR, Guardia Nacional o SEDENA!</h3>
            <p style={{ color: 'var(--text-secondary)', lineHeight: '1.6', marginBottom: 'var(--spacing-xl)', textAlign: 'justify' }}>
              Únete a Ascensos App y al igual que muchos de tus compañeros maximiza tus estudios usando Ascensos App Vortex.
              Elige tu institución y accede a contenido, cuestionarios y simuladores alineados a tu jerarquía y especialidad.
              La aplicación está optimizada para ofrecerte la mejor experiencia posible en tu dispositivo.
            </p>

            <div className="availability-stats">
              <div className="stat-item">
                <span className="stat-value">10K+</span>
                <span className="stat-label">Descargas</span>
              </div>
              <div className="stat-item">
                <span className="stat-value">4.5</span>
                <span className="stat-label">Calificación</span>
              </div>
              <div className="stat-item">
                <span className="stat-value">11.7</span>
                <span className="stat-label">Versión</span>
              </div>
            </div>

            <div style={{ marginBottom: 'var(--spacing-xl)' }}>
              <h4 style={{ marginBottom: 'var(--spacing-md)' }}>Características de la descarga:</h4>
              <ul className="feature-list">
                <li><span>✓</span> Instalación rápida y segura</li>
                <li><span>✓</span> Compatible con Android 8.0+</li>
                <li><span>✓</span> Tamaño optimizado (menos de 50MB)</li>
                <li><span>✓</span> Sin anuncios molestos</li>
                <li><span>✓</span> Actualizaciones automáticas</li>
                <li><span>✓</span> Disponible también como PWA para iOS</li>
              </ul>
            </div>
          </div>

          {/* Download Buttons */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-lg)' }}>
            <div className="download-card">
              <span className="card-badge">Android</span>
              <h3 style={{ marginBottom: 'var(--spacing-lg)' }}>Android — Play Store</h3>

              <div style={{ marginBottom: 'var(--spacing-xl)' }}>
                <a
                  href="https://play.google.com/store/apps/details?id=com.vortex.ascensosappvortex"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="download-btn"
                >
                  <img
                    src="/icons/logo.png"
                    alt="Disponible en Google Play"
                  />
                </a>
              </div>

              <div className="download-badge">
                <div className="version-chip">
                  <span className="version-dot" /> Versión {import.meta.env.VITE_APP_VERSION || '11.7'}
                </div>
                <p style={{ margin: '8px 0 0', color: 'var(--text-muted)', fontSize: '0.95rem' }}>
                  ¡Descarga presionando la imagen!
                </p>
              </div>
            </div>

            <div className="download-card">
              <span className="card-badge card-badge--alt">Web</span>
              <h3 style={{ marginBottom: 'var(--spacing-lg)' }}>iOS / Navegador — PWA</h3>

              <button onClick={handleInstallPWA} className="pwa-install-btn">
                <span style={{ fontSize: '2rem', display: 'block', marginBottom: 'var(--spacing-sm)' }}>
                  {isIOS ? '📱' : '⬇️'}
                </span>
                <span style={{ fontSize: '0.9rem', fontWeight: 600 }}>
                  {isIOS ? 'Instalar en iPhone' : 'Instalar App'}
                </span>
              </button>

              <div className="download-badge" style={{ marginTop: 'var(--spacing-lg)' }}>
                <p style={{ margin: 0, color: 'var(--text-muted)', fontSize: '0.85rem' }}>
                  {isIOS
                    ? 'Agrega Vortex a tu pantalla de inicio como una app nativa'
                    : 'Instala la versión web progresiva en tu dispositivo'}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="howitworks-banner text-center" style={{ marginTop: 'var(--spacing-3xl)' }}>
          <h3 style={{ marginBottom: 'var(--spacing-md)' }}>¿Tienes problemas con la descarga?</h3>
          <p style={{ marginBottom: 'var(--spacing-lg)', textAlign: 'center', color: 'var(--text-secondary)' }}>
            Nuestro equipo de soporte está aquí para ayudarte. Contacta con nosotros si necesitas asistencia.
          </p>
          <a href="#contact" className="btn btn-primary">
            Contactar equipo
          </a>
        </div>
      </div>

      {showIOSGuide && <IOSInstallGuide onClose={() => setShowIOSGuide(false)} />}

      {showBrowserGuide && (
        <div
          onClick={() => setShowBrowserGuide(false)}
          style={{
            position: 'fixed', inset: 0, zIndex: 1200,
            background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(4px)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: '20px',
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: 'linear-gradient(135deg, #0d2035 0%, #071526 100%)',
              border: '1px solid rgba(197, 160, 89, 0.4)',
              borderRadius: '16px', padding: '24px',
              maxWidth: '380px', width: '100%',
              boxShadow: '0 8px 32px rgba(0,0,0,0.8), 0 0 20px rgba(197,160,89,0.2)',
              fontFamily: 'var(--font-primary)',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
              <h4 style={{
                margin: 0, fontFamily: "'Orbitron', sans-serif",
                fontSize: '0.9rem', color: '#c5a059',
                letterSpacing: '1px', textTransform: 'uppercase',
              }}>Instalar Vortex App</h4>
              <button
                onClick={() => setShowBrowserGuide(false)}
                style={{
                  background: 'transparent', border: 'none',
                  color: 'rgba(181,200,216,0.6)', fontSize: '1rem',
                  cursor: 'pointer', padding: 0, lineHeight: 1,
                }}
              >
                ✕
              </button>
            </div>

            <p style={{ margin: '0 0 16px', fontSize: '0.75rem', color: 'rgba(181,200,216,0.85)', lineHeight: 1.4 }}>
              Abre el menú de tu navegador y selecciona <strong>&quot;Añadir a pantalla de inicio&quot;</strong> o <strong>&quot;Instalar aplicación&quot;</strong>:
            </p>

            <div style={{
              display: 'flex', flexDirection: 'column', gap: '12px',
              fontSize: '0.75rem', color: 'white',
              background: 'rgba(255,255,255,0.03)',
              padding: '12px', borderRadius: '8px',
              border: '1px solid rgba(255,255,255,0.05)',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <span style={{
                  background: 'rgba(197,160,89,0.2)', color: '#c5a059',
                  width: '20px', height: '20px', borderRadius: '50%',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '0.65rem', fontWeight: 'bold', flexShrink: 0,
                }}>1</span>
                <span>Pulsa el icono de menú <strong>⁝</strong> (Chrome) o <strong>⚙</strong> (Safari) en tu navegador.</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <span style={{
                  background: 'rgba(197,160,89,0.2)', color: '#c5a059',
                  width: '20px', height: '20px', borderRadius: '50%',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '0.65rem', fontWeight: 'bold', flexShrink: 0,
                }}>2</span>
                <span>Desliza y selecciona <strong>Añadir a pantalla de inicio</strong> o <strong>Instalar app</strong>.</span>
              </div>
            </div>

            <button
              onClick={() => setShowBrowserGuide(false)}
              style={{
                width: '100%', marginTop: '16px',
                background: 'rgba(197,160,89,0.1)',
                border: '1px solid rgba(197,160,89,0.3)',
                borderRadius: '6px', color: '#c5a059',
                fontFamily: "'Orbitron', sans-serif",
                fontSize: '0.7rem', fontWeight: '700',
                padding: '10px 0', cursor: 'pointer',
                textTransform: 'uppercase', letterSpacing: '1px',
              }}
            >
              Entendido
            </button>
          </div>
        </div>
      )}
    </section>
  )
}